import { useCallback } from 'react';

import { VOID_FUNCTION } from 'constants/index';

import { ADDRESS_HANDLER_KEYS } from 'components/modules/Insurance/components/Policyholder/Policyholder.constants';
import { useBooleanControl } from 'components/modules/Insurance/hooks/useBooleanControl';

import { generateAddress } from '../Passport.helpers';

export const useManualAddress = ({ name, onChange: onChangeProp = VOID_FUNCTION }) => {
  const { onDisable, ...control } = useBooleanControl();

  const onSave = useCallback(
    (data) => {
      onDisable();
      onChangeProp({
        [name]: {
          [ADDRESS_HANDLER_KEYS.ADDRESS]: generateAddress(data),
          [ADDRESS_HANDLER_KEYS.DA_DATA]: data,
          [ADDRESS_HANDLER_KEYS.IS_DA_DATA]: false,
        },
      });
    },
    [onDisable, onChangeProp, name]
  );

  return { ...control, onDisable, onSave };
};
